module.exports = __webpack_public_path__ + "static/media/comarch.2dd0802a.jpeg";